const Font = require("../../util/Font");
const {
	findArguments,
	findOptionalArgument,
	makeNonmathCommandNode,
} = require("../util/ParserHelpers");
const {getLineWidth} = require("../util/RenderHelpers");

const encircleNonmathParser = function(ps) {
	const optArg1 = findOptionalArgument(ps);
	const cancel = optArg1 ? optArg1.text : false;

	const nodes = makeNonmathCommandNode("encircle", findArguments(ps, 1));
	if (nodes) {
		nodes[0].cancel = cancel;
	}
	return nodes;
};

const encircleMathParser = function(ps) {
	const optArg1 = findOptionalArgument(ps);
	const cancel = optArg1 ? optArg1.text : false;
	const args = findArguments(ps, 1);
	if (!args) {
		ps.pushError("\\encircle is missing its required parameter.");
		return [
			{
				type: "error",
			},
		];
	}
	return [
		{
			type: "encircle",
			cancel: cancel,
			children: [
				{
					type: "math",
					children: ps.parseMath(args[0]),
				},
			],
		},
	];
};

const encircleNode = {
	draw(rc, x, y, node, measure) {
		const context = rc.context;
		const {
			fontInfo,
			width,
			top,
			encircledContentMeasure,
			leftOperator,
		} = measure;
		const lineWidth = getLineWidth(rc, fontInfo);

		if (node.children.length) {
			rc.drawNode(
				rc,
				x +
					(width -
						encircledContentMeasure.width -
						(leftOperator ? fontInfo.size * 0.35 : 0)) /
						2,
				y,
				node.children[0]
			);
		}

		// Draw "circle" around content
		context.save();
		context.lineWidth = lineWidth;
		context.beginPath();
		context.moveTo(x + width / 2, y - top + lineWidth);
		context.bezierCurveTo(
			x + width * 0.65 - lineWidth,
			y - top + lineWidth,
			x + width - lineWidth,
			y - top * 0.8 + lineWidth,
			x + width - lineWidth,
			y
		);
		context.bezierCurveTo(
			x + width - lineWidth,
			y + top * 0.8 - lineWidth,
			x + width * 0.65 - lineWidth,
			y + top - lineWidth,
			x + width / 2,
			y + top - lineWidth
		);
		context.bezierCurveTo(
			x + lineWidth + width * 0.35,
			y + top - lineWidth,
			x + lineWidth,
			y + top * 0.8 - lineWidth,
			x + lineWidth,
			y
		);
		context.bezierCurveTo(
			x + lineWidth,
			y - top * 0.8 + lineWidth,
			x + lineWidth + width * 0.35,
			y - top + lineWidth,
			x + width / 2,
			y - top + lineWidth
		);
		context.closePath();
		context.stroke();
		context.restore();

		// If cancelled, also draw the X (not using nested cancel/encircle commands because
		// the X is too large)
		// backslash
		if (node.cancel === "xcancel" || node.cancel === "lcancel") {
			context.save();
			context.beginPath();
			context.lineWidth = lineWidth;
			context.M(x + fontInfo.size * 0.15, y - top + fontInfo.size * 0.15);
			context.L(
				x + measure.width - fontInfo.size * 0.15,
				y + top - fontInfo.size * 0.15
			);
			context.closePath();
			context.stroke();
			context.restore();
		}
		// forward slash
		if (node.cancel === "xcancel" || node.cancel === "cancel") {
			context.save();
			context.beginPath();
			context.lineWidth = lineWidth;
			context.M(
				x + width - fontInfo.size * 0.15,
				y - top + fontInfo.size * 0.15
			);
			context.L(x + fontInfo.size * 0.15, y + top - fontInfo.size * 0.15);
			context.closePath();
			context.stroke();
			context.restore();
		}
	},
	measure(rc, fontInfo, props, node) {
		let encircledContentMeasure;
		const lineWidth = getLineWidth(rc, fontInfo);

		// Calculate inner dimensions
		if (node.children[0].children.length) {
			encircledContentMeasure = rc.measureNode(
				rc,
				fontInfo,
				props,
				node.children[0]
			);
		} else {
			const numSpaces = !node.numSpaces ? 1 : node.numSpaces;
			const context = rc.context;
			let boxText = "";
			for (let c = 0; c < numSpaces; c++) {
				boxText += "0";
			}
			context.save();
			context.font = Font.fromInfo(fontInfo);
			encircledContentMeasure = {
				width: context.measureText(boxText).width,
				top: fontInfo.size / 2,
				bottom: fontInfo.size / 2,
			};
			context.restore();
		}

		// Allow the encircling to get closer to left side if it begins with an operator
		// and provide a baseline width to shift the contents for drawing
		let leftOperator = false;
		if (
			(node.children[0] &&
				node.children[0].type === "math" &&
				node.children[0].children.length &&
				node.children[0].children[0].type === "operator") ||
			(node.children[0] &&
				node.children[0].type === "nonmath" &&
				node.children[0].children.length &&
				node.children[0].children[0].type === "math" &&
				node.children[0].children[0].children.length &&
				node.children[0].children[0].children[0].type === "operator")
		) {
			leftOperator = true;
		}

		return {
			width:
				encircledContentMeasure.width +
				4 * lineWidth +
				fontInfo.size * 0.8 -
				(leftOperator ? fontInfo.size * 0.5 : 0),
			top: encircledContentMeasure.top + 2 * lineWidth + fontInfo.size * 0.25,
			bottom:
				encircledContentMeasure.bottom + 2 * lineWidth + fontInfo.size * 0.25,
			fontInfo,
			encircledContentMeasure,
			leftOperator,
		};
	},
	readAloud: {children: true},
};

module.exports = {
	parsers: {
		nonmathCommands: {
			encircle: encircleNonmathParser,
		},
		mathCommands: {
			encircle: encircleMathParser,
		},
	},
	nodes: {
		encircle: encircleNode,
	},
};
